import moment from 'moment';
import { find } from 'underscore';


const getDiscount = (params, discount) => {
    var dt_in = moment(params.dt, "DD.MM.YYYY"),
        hotel_regexp = RegExp('(^|[^\d])' + params.hotel + '([^\d]|$)'),
        result = {'proc': 0, 'currency_discount': 0,  'text': '', 'active': false};
        const row = find(discount, function(item) {
          return (
            (item.depart == null || item.depart == params.depart) &&
            (item.country == null || item.country == params.country) &&
            (item.oper == null || item.oper == params.oper) &&
            // (item.hotel == null || hotel_regexp.test(item.hotel)) &&
            (item.region == null || item.region == params.region) &&
            (item.subregion == null || item.subregion == params.subregion) &&
            (item.adult == null || item.adult == params.adult) &&
            (item.child == null || item.child == params.child) &&
            (item.meal == null || item.meal == params.meal) &&
            (dt_in.isBetween(item.d1, item.d2, 'days', '[]'))
          );
        });
    if (row) {
      if (row.discount.proc > 0) {
          result.proc = row.discount.proc;
      } else {
          result.currency_discount = row.discount[params.currency.toLowerCase()] || 0;
      }
      result.text = row.text;
      result.active = true;
    }
    return result;
}

export default getDiscount;